"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWorkflowRequestDec = exports.CreateWorkflowRequest = void 0;
const D = __importStar(require("io-ts/lib/Decoder"));
const codecs_1 = require("../../codecs");
const function_1 = require("fp-ts/lib/function");
class CreateWorkflowRequest {
}
exports.CreateWorkflowRequest = CreateWorkflowRequest;
exports.CreateWorkflowRequestDec = (0, function_1.pipe)(D.struct({
    workflowType: codecs_1.WorkflowTypeDec,
    resourceId: D.string,
    resourceTitle: D.string,
    cwmClassType: D.string,
    cwmClassTypeLabel: D.string,
    assignee: D.nullable(D.string),
    workflowConfig: D.UnknownRecord,
    deadlineAt: D.nullable(codecs_1.DateFromISOString),
}), D.withMessage(() => 'CreateWorkflowRequest'));
//# sourceMappingURL=CreateWorkflowRequest.dto.js.map